// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__15Uh5","inputWrap":"styles_inputWrap__3pIq4","input":"styles_input__U5-HW"};